import type {KilnLayout} from '@domain/kiln-monitoring'

import {checkIsNameSetUp, checkKilnPartBoundaries} from './utils'

import type {KilnConfiguration} from '@kilnfeature/types'

export const getIsDriveConfigValid = (
  kilnLayout: KilnLayout,
  kilnConfiguration: KilnConfiguration
) => {
  const kilnLength = Number(kilnConfiguration.dimensions.length) ?? 0

  const isDriveNameSetUp = checkIsNameSetUp(kilnLayout.drive.name)
  const areDriveBoundariesSetUp = checkKilnPartBoundaries(kilnLayout.drive, kilnLength)

  const isDriveConfigVaid = isDriveNameSetUp && areDriveBoundariesSetUp

  return {
    isDriveConfigVaid,
    details: {isDriveNameSetUp, areDriveBoundariesSetUp}
  }
}
